"use strict";

exports.__esModule = true;
exports.CommentWordCountBarChart = void 0;
var _react = _interopRequireWildcard(require("react"));
var _d3Format = require("d3-format");
var _d3Scale = require("d3-scale");
var _d3ScaleChromatic = require("d3-scale-chromatic");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Charts = require("../../Charts");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ScrollWrapper = _styledComponents["default"].div.withConfig({
  displayName: "CommentWordCountBarChart__ScrollWrapper",
  componentId: "sc-1wm6jtt-0"
})(["overflow:auto;"]);
function createLinearScaleForComments(from, to, values) {
  var scale = (0, _d3Scale.scaleLinear)().rangeRound([from, to]).domain([0, Math.max.apply(Math, values)]);
  scale.nice().tickFormat((0, _d3Format.format)("d"));
  return scale;
}
var CommentWordCountBarChart = exports.CommentWordCountBarChart = /*#__PURE__*/function (_Component) {
  function CommentWordCountBarChart() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(CommentWordCountBarChart, _Component);
  var _proto = CommentWordCountBarChart.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      width = _this$props.width,
      height = _this$props.height,
      left = _this$props.x,
      top = _this$props.y,
      _this$props$data = _this$props.data,
      data = _this$props$data === void 0 ? {} : _this$props$data;
    var style = {
      top: top,
      left: left,
      width: width,
      height: height
    };
    var increment = 1 / data.length + 1;
    var colors = data.map(function (item, index) {
      return (0, _d3ScaleChromatic.interpolateSinebow)(increment * index);
    });
    var last = 0;
    var getColor = function getColor() {
      return colors[last++ % colors.length];
    };
    var BAR_HEIGHT = 14;
    var PADDING = 4;
    var X_AXIS_HEIGHT = 30;
    var calculateHeight = data.length * (BAR_HEIGHT + 2) + PADDING * 2 + X_AXIS_HEIGHT;
    return /*#__PURE__*/_react["default"].createElement(ScrollWrapper, {
      style: {
        height: style.height,
        width: style.width
      }
    }, /*#__PURE__*/_react["default"].createElement(_Charts.ComboChart, _extends({
      createXScale: createLinearScaleForComments,
      xAxisHeight: X_AXIS_HEIGHT,
      padding: PADDING
    }, Object.assign({}, style, {
      height: calculateHeight
    }), {
      yAxisWidth: 100,
      orientation: "horizontal",
      series: [{
        data: data.map(function (item) {
          return {
            y: item[0],
            x: item[1]
          };
        }),
        render: function render(props) {
          return /*#__PURE__*/_react["default"].createElement(_Charts.HorizontalBarChartSeries, _extends({
            color: getColor
          }, props, {
            barWidth: BAR_HEIGHT
          }));
        }
      }]
    })));
  };
  return CommentWordCountBarChart;
}(_react.Component);
CommentWordCountBarChart.defaultProps = {
  device: undefined,
  devices: undefined,
  reportingPeriod: undefined
};